module.exports = __webpack_public_path__ + "assets/img/haiyun.5ac06289.png";